import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { canViewPricingReports } from "../../common/utils/pricingReportsAccess";
import { beefAiConfigured } from "../../services/beefAiPricing";
import FlyerReportPanelContent from "./FlyerReportPanelContent";
import { useFlyerReportPanelState } from "./useFlyerReportPanelState";

export function FlyerReportPanel() {
  const user = useSelector((state) => state.user);
  const userMayViewPricingReports = canViewPricingReports(user);
  const beefAiClientConfigured = beefAiConfigured();

  const panelState = useFlyerReportPanelState({
    queriesEnabled: userMayViewPricingReports && beefAiClientConfigured,
  });

  if (!userMayViewPricingReports) {
    return (
      <Box sx={{ py: 1 }}>
        <Alert severity="warning">
          You do not have access to Flyer Report. If you believe this is a mistake, contact your Canada Beef
          administrator.
        </Alert>
        <Button component={Link} to="/dashboard" sx={{ mt: 2 }} variant="contained">
          Back to dashboard
        </Button>
      </Box>
    );
  }

  if (!beefAiClientConfigured) {
    return (
      <Box sx={{ py: 1 }}>
        <Alert severity="warning">
          Flyer Report is not configured. Set `REACT_APP_PRICE_DIRECTUS_URL` and `REACT_APP_PRICE_DIRECTUS_TOKEN` for
          this environment, then reload the page.
        </Alert>
      </Box>
    );
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <FlyerReportPanelContent panelState={panelState} />
    </LocalizationProvider>
  );
}

export default FlyerReportPanel;

export { useFlyerReportPanelState, flyerReportSwrOptions } from "./useFlyerReportPanelState";
